import React, { useState, useMemo } from "react";
import { products, categories, WHATSAPP_NUMBER } from "../../mock";

const Catalog = () => {
  const [active, setActive] = useState("Todos");

  const filtered = useMemo(() => {
    if (active === "Todos") return products;
    if (active === "Mais procurados") return products.filter((p) => p.featured);
    return products.filter((p) => p.category === active);
  }, [active]);

  return (
    <section id="brinquedos" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5">
        <span className="text-sm font-bold tracking-[0.2em] text-[#ec4899] uppercase">
          Nosso catálogo
        </span>
        <h2 className="mt-4 font-display font-bold text-white text-3xl md:text-5xl leading-tight">
          Conheça nossos brinquedos
        </h2>
        <p className="mt-6 text-gray-400 text-lg max-w-2xl leading-relaxed">
          Escolha os favoritos da criançada e peça seu orçamento direto pelo
          WhatsApp.
        </p>

        {/* Filters */}
        <div className="mt-10 flex flex-wrap gap-3">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              className={`rounded-full px-6 py-2.5 text-sm font-semibold transition-all ${
                active === cat
                  ? "bg-gradient-to-r from-[#ec4899] to-[#f472b6] text-white shadow-lg shadow-pink-500/25"
                  : "bg-[#15131f] text-gray-300 border border-white/10 hover:border-white/25 hover:text-white"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {filtered.map((p) => (
            <article
              key={p.id}
              className="group flex flex-col rounded-3xl overflow-hidden bg-black border border-white/10 transition-all duration-300 hover:-translate-y-2 hover:border-[#ec4899]/40 hover:shadow-2xl hover:shadow-black/50"
            >
              {/* Full banner image — shown complete, never cropped */}
              <div className="bg-black">
                <img
                  src={p.image}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-auto block"
                />
              </div>

              <div className="p-5 mt-auto">
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
                    `Olá, vim do site da Casagrande Brinquedos. Gostaria de saber os detalhes do brinquedo "${p.name}", preciso de um orçamento.`
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                  className="block text-center rounded-full bg-[#ec4899] hover:bg-[#db2777] text-white font-bold py-3.5 transition-all hover:-translate-y-0.5"
                >
                  Quero este
                </a>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-12 text-center text-gray-500">
            Nenhum brinquedo nesta categoria no momento.
          </p>
        )}
      </div>
    </section>
  );
};

export default Catalog;
